import type { NextPage } from 'next'

import Subdelegated from 'views/subdelegated'

const SubdelegatedPage: NextPage = () => <Subdelegated />

export default SubdelegatedPage

export async function getStaticProps() {
  return {
    props: {
      SEO: {
        title: 'CashMe | Seja um Substabelecido e conheça as vantagens',
        description:
          'Conheça as principais vantagens e se cadastre para aumentar sua renda de forma totalmente online. Seja um Substabelecido!'
      }
    }
  }
}
